import { Sidebar } from "@/components/styleguide/Sidebar";
import { LIBRARY_NAV } from "@/data/libraryNav";
import { LibraryHero } from "@/components/library/LibraryHero";
import { NavigationSection } from "@/components/library/sections/NavigationSection";
import { ButtonsSection } from "@/components/library/sections/ButtonsSection";
import { CardsSection } from "@/components/library/sections/CardsSection";
import { ProgressSection } from "@/components/library/sections/ProgressSection";
import { RewardsSection } from "@/components/library/sections/RewardsSection";
import { QuestionsSection } from "@/components/library/sections/QuestionsSection";
import { InputsSection } from "@/components/library/sections/InputsSection";
import { FeedbackSection } from "@/components/library/sections/FeedbackSection";
import { LoadingSection } from "@/components/library/sections/LoadingSection";
import { ListsSection } from "@/components/library/sections/ListsSection";
import { LibraryMotionSection } from "@/components/library/sections/LibraryMotionSection";
import { AgeAdaptationSection } from "@/components/library/sections/AgeAdaptationSection";
import { FooterSection } from "@/components/styleguide/sections/FooterSection";

export default function LibraryPage() {
  return (
    <div className="App min-h-screen overflow-x-clip bg-background text-foreground antialiased">
      <Sidebar items={LIBRARY_NAV} subtitle="Component Library" />
      <main className="lg:pl-72">
        <LibraryHero />
        <div className="mx-auto w-full max-w-content px-5 sm:px-8 lg:px-12">
          <NavigationSection />
          <ButtonsSection />
          <CardsSection />
          <ProgressSection />
          <RewardsSection />
          <QuestionsSection />
          <InputsSection />
          <FeedbackSection />
          <LoadingSection />
          <ListsSection />
          <LibraryMotionSection />
          <AgeAdaptationSection />
        </div>
        <FooterSection />
      </main>
    </div>
  );
}
